import { Controller } from "@hotwired/stimulus"

// Condivisione evento. Facebook/WhatsApp sono link diretti; Instagram non ha
// un intent di condivisione web, quindi copiamo il link negli appunti.
export default class extends Controller {
  static values = { url: String }
  static targets = ["feedback"]

  copy() {
    const done = () => this.flash()
    if (navigator.clipboard) {
      navigator.clipboard.writeText(this.urlValue).then(done).catch(done)
    } else {
      done()
    }
  }

  flash() {
    if (!this.hasFeedbackTarget) return
    this.feedbackTarget.hidden = false
    setTimeout(() => { this.feedbackTarget.hidden = true }, 2000)
  }
}
